<div class="catalog-content">
    <form
        name="form"
        (ngSubmit)="f.form.valid && processData()"
        #f="ngForm"
        novalidate
    >
    <div class="row">
        <!--TITLE-->
        <div class="col-md-6">
            <div class="form-group">
                    <mat-form-field>
                        <input
                        matInput
                        placeholder="Enter title"
                        [(ngModel)]="digitalFactsheetDataObj.digitalFactsheetTitle"
                        name="digitalFactsheetTitle"
                        #digitalFactsheetTitle="ngModel"
                        required
                        />
                        <mat-error *ngIf="f.submitted && digitalFactsheetTitle.invalid">Title is required</mat-error>
                    </mat-form-field>
            </div>
        </div>
        <!--URL-->
        <div class="col-md-6">
            <div class="form-group">
                    <mat-form-field>
                        <input
                        matInput
                        placeholder="Enter URL"
                        [(ngModel)]="digitalFactsheetDataObj.digitalFactsheetUrl"
                        name="digitalFactsheetUrl"
                        #digitalFactsheetUrl="ngModel"
                        required
                        (keypress)="keyPressURL($event)"
                        />
                        <mat-error *ngIf="digitalFactsheetUrl.invalid">Please Enter valid URL</mat-error>
                    </mat-form-field>
            </div>
        </div>
    </div>

    <!-- BUTTON -->
    <div class="margin-top-20 text-center">
        <button mat-raised-button color="primary" class="mat-button-large" type="submit" [disabled]="!f.valid">
            Submit
        </button>
    </div>
    </form>
    <app-catalog-digital-factsheet-list [data]="digitalFactsheetList"></app-catalog-digital-factsheet-list> 
</div>
